/**
 * Created by razial on 04.09.2025.
 */

const ExtraBarIconView = cc.Node.extend({
    ctor: function (row) {
        this._super();

        this.row = row;

        const styles = cleverapps.styles.ExtraBarIconView;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles.width, styles.height);

        this.createBackground();
        this.createIcon();
        this.updateTitle();
        this.updateAttention();

        this.setCascadeOpacityEnabledRecursively(true);

        cleverapps.UI.onClick(this, () => {
            this.onPressed();
        });
        cleverapps.UI.applyHover(this);

        this.row.data.onChangeTitleListener = this.createListener(this.updateTitle.bind(this));
        this.row.data.onStartTimerListener = this.createListener(this.updateTitle.bind(this));
        this.row.data.onRemoveTimerListener = this.createListener(this.updateTitle.bind(this));
        this.row.data.onAttentionOnListener = this.createListener(this.updateAttention.bind(this));
        this.row.data.onAttentionOffListener = this.createListener(this.updateAttention.bind(this));
        this.row.data.onShowForce = this.createListener(this.showForce.bind(this));
    },

    createBackground: function () {
        const icon = this.row.data.getExtraBarIcon();

        const frame = icon && icon.background || PseudoRandom.GET().choose([
            bundles.extrabar.frames.extrabar_icon_bg_blue,
            bundles.extrabar.frames.extrabar_icon_bg_green,
            bundles.extrabar.frames.extrabar_icon_bg_orange,
            bundles.extrabar.frames.extrabar_icon_bg_purple
        ], String(icon && icon.json));

        this.background = new cc.Sprite(frame);
        this.background.setAlignment(cleverapps.styles.ExtraBarIconView.background);
        this.addChild(this.background);
    },

    createIcon: function () {
        const icon = this.row.data.getExtraBarIcon();
        if (!icon || !icon.json) {
            return;
        }

        this.icon = new cleverapps.Spine(icon.json);
        this.icon.setAlignment(cleverapps.styles.ExtraBarIconView.icon);
        this.addChild(this.icon);

        const skin = this.row.data.skin;
        if (skin && this.icon.hasSkin(skin)) {
            this.icon.setSkin(skin);
        }

        this.icon.setAnimation(0, "animation", false);

        this.icon.setCompleteListener(() => {
            this.icon.runAction(new cc.Sequence(
                new cc.DelayTime(PseudoRandom.GET().mathChoose(ExtraBarIconView.RANDOM_ANIMATION_INTERVALS)),
                new cc.CallFunc(() => {
                    this.icon.setAnimation(0, "animation", false);
                })
            ));
        });
    },

    updateTitle: function () {
        if (this.timer) {
            this.timer.remove();
            delete this.timer;
        }

        if (this.title) {
            this.title.removeFromParent();
            delete this.title;
        }

        const timeLeft = this.row.data.getLeftTime();
        if (timeLeft > 0) {
            this.createTimer();
            return;
        }

        const title = this.row.data.getTitle();
        if (title) {
            this.createText();
        }
    },

    createTimer: function () {
        const timeLeft = this.row.data.getLeftTime();

        const timer = this.timer = new cleverapps.CountDown(timeLeft, {
            onFinish: () => {
                this.row.data.resetState();
            }
        });

        const styles = cleverapps.styles.ExtraBarIconView.title;

        let background = undefined;
        if (bundles.extrabar.frames.extrabar_title_bg) {
            background = cleverapps.UI.createScale9Sprite(bundles.extrabar.frames.extrabar_title_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
            background.setContentSize2(styles.width, styles.height);
        }

        const timerTitle = this.title = new cleverapps.CountDownView(timer, {
            font: cleverapps.styles.FONTS.EXTRABAR_ICON_TEXT,
            timerPosition: { x: 0, y: styles.offsetY },
            background_content: background
        });

        const textSize = {
            width: styles.width * styles.factorX,
            height: styles.height * styles.factorY
        };

        timerTitle.fitTo(textSize.width, textSize.height);
        timerTitle.baseScale = timerTitle.scale;

        this.addChild(timerTitle);
        timerTitle.setAlignment(styles);
    },

    createText: function () {
        const styles = cleverapps.styles.ExtraBarIconView.title;

        let background;
        if (bundles.extrabar.frames.extrabar_title_bg) {
            background = cleverapps.UI.createScale9Sprite(bundles.extrabar.frames.extrabar_title_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        } else {
            background = new cc.Node();
        }
        this.title = background;
        background.setContentSize2(styles.width, styles.height);
        background.setAlignment(styles);
        this.addChild(background);

        const title = this.row.data.getTitle();

        let text;

        if (TextWithIcon.IsApplicable(title)) {
            text = new TextWithIcon(title, { font: cleverapps.styles.FONTS.EXTRABAR_ICON_TEXT });
        } else {
            // eslint-disable-next-line no-restricted-syntax
            text = cleverapps.UI.generateTTFText(title, cleverapps.styles.FONTS.EXTRABAR_ICON_TEXT);
        }

        text.setAlignment(background.width / 2, background.height / 2 + styles.offsetY);

        const textSize = {
            width: styles.width * styles.factorX,
            height: styles.height * styles.factorY
        };

        text.fitTo(textSize.width, textSize.height);
        text.baseScale = text.scale;
        background.addChild(text);
    },

    updateAttention: function () {
        if (this.attention) {
            this.attention.removeFromParent();
            delete this.attention;
        }

        const attention = this.row.data.getAttention();
        if (attention) {
            const styles = cleverapps.styles.ExtraBarIconView.attention;

            const attention = this.attention = new Attention();
            attention.setAlignment(styles);
            this.addChild(attention);
        }
    },

    showForce: function () {
        cleverapps.forces.create(this, this.row.data.getForce());
    },

    onPressed: function () {
        if (cleverapps.forces.isRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }

        this.row.data.onPressed();
    }
});

ExtraBarIconView.RANDOM_ANIMATION_INTERVALS = [5, 7, 9, 11, 12];

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EXTRABAR_ICON_TEXT: {
        name: "default",
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.ExtraBarIconView = {
    width: 140,
    height: 140,
    margin: 25,

    title: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -2 },

        width: 144,
        height: 40,
        offsetY: 0,
        factorX: 0.86,
        factorY: 1.20
    },

    icon: {
        x: { align: "center" },
        y: { align: "center" }
    },

    background: {
        x: { align: "center" },
        y: { align: "center" }
    },

    attention: {
        x: { align: "right", dx: -5 },
        y: { align: "top", dy: -5 }
    }
};
